// MobileMenu
import React from 'react';
import { connect } from 'react-redux';

import ClassNames from 'classnames';


@connect((Store) => {
  return {
    mobileSelected: Store.chat.mobileSelected
  };
})

export default class MobileMenu extends React.Component {
  handleClick(panelToOpen) {
      this.props.mobilePanelChange(panelToOpen);
   }

  isSelected(element) {
    let isHidden = false;

    if (element != 'admin_activity'){
      if ((this.props.mobileSelected == 'welcomehelper' || this.props.mobileSelected == 'filters')
        && (element == 'filters_' || element == 'threads')) {
        isHidden = true;
      } else if (this.props.mobileSelected == 'threads'
        && (element == 'filters' || element == 'threads')) {
        isHidden = true;
      } else if (this.props.mobileSelected == 'thread_form'
        && (element == 'filters_' || element == 'threads')) {
        isHidden = true;
      } else if (this.props.mobileSelected == 'messages'
        && (element == 'filters' || element == 'filters_')) {
        isHidden = true;
      } else if (this.props.mobileSelected == 'admin_activity'
        && (element == 'filters_' || element == 'threads')) {
        isHidden = true;
      } else if (this.props.mobileSelected == 'insider_form'
        && (element == 'threads' || element == 'filters_')) {
        isHidden = true;
      }
    }

    const itemClass = {
      'selected': (this.props.mobileSelected && this.props.mobileSelected == element),
      'hidden': isHidden,
      'fright': (element == 'thread_form' || element == 'admin_activity'),
      'brandedColorLightBis_color': (this.props.mobileSelected && this.props.mobileSelected == element)
    };

    itemClass['m_' + element] = true;

    return ClassNames(itemClass);
  }

  render() {
    return (
      <div className='mobile-menu'>
        <ul>
          <li className={this.isSelected('filters')} onClick={this.handleClick.bind(this, 'filters')}><i className="pe-7s-chat"></i></li>
          <li className={this.isSelected('filters_')} onClick={this.handleClick.bind(this, 'filters')}><i className="pe-7s-angle-left-circle"></i></li>
          <li className={this.isSelected('threads')} onClick={this.handleClick.bind(this, 'threads')}><i className="pe-7s-angle-left-circle"></i></li>

          <li className={this.isSelected('admin_activity')} onClick={this.handleClick.bind(this, 'admin_activity')}><i className="pe-7s-users"></i></li>
          <li className={this.isSelected('thread_form')} onClick={this.handleClick.bind(this, 'thread_form')}>
            <i className="pe-7s-comment"></i>
            <i className="pe-7s-plus"></i>
          </li>
        </ul>
      </div>
    );
  }


};



// WEBPACK FOOTER //
// ./src/components/mobile/MobileMenu.jsx